import React from "react";
import "./CustomSelectOptimize.css"

const CustomSelectOptimize = () => {

    return (
        <div>
            <div className="custom-annual-expenses">Desired end of Analysis Value:</div>
            <input className="custom-eol-amount border-1px-mischka" 
                placeholder="$"
                type="number">
            </input>
        </div>
    );
};

export default CustomSelectOptimize;